import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactElement, ReactNode } from "react";
import { ThemeProvider } from "next-themes";

import { AppContextBanner } from "@/components/AppContextBanner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { AuthSync } from "@/providers/AuthSync";
import { CountryLocaleOverlay } from "@/providers/CountryLocaleOverlay";
import { OrgFormatSync } from "@/providers/OrgFormatSync";
import { PersonLanguageSync } from "@/providers/PersonLanguageSync";
import { VisualViewportHeightSync } from "@/providers/VisualViewportHeightSync";
import { InactivityTimeout } from "@/providers/InactivityTimeout";
import { queryClient } from "@/lib/queryClient";

type AppProvidersProps = {
  children: ReactNode;
};

export function AppProviders({ children }: AppProvidersProps): ReactElement {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        storageKey="konstrulog-theme"
        disableTransitionOnChange
      >
        <AuthSync />
        <PersonLanguageSync />
        <OrgFormatSync />
        <CountryLocaleOverlay />
        <VisualViewportHeightSync />
        <InactivityTimeout />
        <AppContextBanner />
        <TooltipProvider delayDuration={300}>{children}</TooltipProvider>
        <Toaster />
      </ThemeProvider>
    </QueryClientProvider>
  );
}
